import { render, staticRenderFns } from "./NavphoneBlack.vue?vue&type=template&id=ba347172&scoped=true&"
import script from "./NavphoneBlack.vue?vue&type=script&lang=js&"
export * from "./NavphoneBlack.vue?vue&type=script&lang=js&"
import style0 from "./NavphoneBlack.vue?vue&type=style&index=0&id=ba347172&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba347172",
  null
  
)

export default component.exports